import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Gochujang Sauce',
  source: 'https://www.seriouseats.com/sweet-and-spicy-chili-sauce-korean-fried-chicken-recipe',
  totalTime: time(0, 5),
  servings: 4,
  tags: { type: 'sauce' },
  ingredients: [
    { name: 'gochujang', quantity: '1/4', unit: 'cup' },
    { name: 'soy sauce', quantity: '2', unit: 'tbsp' },
    { name: 'rice wine vinegar', quantity: '1', unit: 'tbsp' },
    { name: 'dark brown sugar', quantity: '3', unit: 'tbsp' },
    { name: 'garlic', quantity: '3', unit: 'medium cloves', customUnit: true,
      note: 'minced',
    },
    { name: 'fresh ginger', quantity: '1', unit: 'tsp',
      note: 'grated',
    },
    { name: 'toasted sesame oil', quantity: '1', unit: 'tbsp' },
  ],
  directions: [
    {
      title: 'Combine Ingredients',
      bullets: [
        "In large bowl, whisk together {gochujang}, {soy sauce}, {rice wine vinegar}, {dark brown sugar}, {garlic}, {fresh ginger} & {toasted sesame oil}",
      ],
    },
    {
      title: 'Adjust Thickness',
      bullets: [
        "Add up to {=2 tbsp} water until sauce is barely thin enough to drop off inverted spoon",
      ],
    },
  ],
};

export default recipe;
